import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { CommonService } from '@services/common.service';
import { LOOP } from '@splidejs/splide';
import { CarouselWrapperComponent } from '../carousel-wrapper/carousel-wrapper.component';
import { ImagePipe } from '@pipes/image.pipe';
import { map } from 'rxjs';
import { getStaticBanner } from '@mocks/home.mock';

@Component({
  selector: 'market-carousel-banner',
  standalone: true,
  imports: [CommonModule, CarouselWrapperComponent, AsyncPipe, ImagePipe],
  templateUrl: './carousel-banner.component.html',
  styleUrls: ['./carousel-banner.component.scss'],
})
export class CarouselBannerComponent {
  @ViewChild('splide') splide!: ElementRef<HTMLElement>;

  images$ = inject(CommonService)
    .getBanners()
    .pipe(map(x => x.data ?? getStaticBanner()));
  get options() {
    return {
      type: LOOP,
      arrows: false,
      autoplay: true,
    };
  }
}
